// This service module capture any user click (or scroll) in the window and inform listeners
const {addRemove} = require("mytime-common/collections");

let anyActionListeners = [];

window.addEventListener('click', (e)=> {
    anyActionListeners.forEach((l) => l(e));
});
// document.body.addEventListener('scroll', (e)=> {
//     anyActionListeners.forEach((l) => l(e));
// });

const anyAction = addRemove(anyActionListeners);

exports.anyAction = anyAction;
